import { render, staticRenderFns } from "./RealnameAuthentication.vue?vue&type=template&id=45dea721&scoped=true"
import script from "./RealnameAuthentication.vue?vue&type=script&lang=js"
export * from "./RealnameAuthentication.vue?vue&type=script&lang=js"
import style0 from "./RealnameAuthentication.vue?vue&type=style&index=0&id=45dea721&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dea721",
  null
  
)

export default component.exports